import React, { createContext, memo, useContext } from 'react';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import cx from 'classnames';
import { isEmpty } from 'lodash';
import LightTooltip from 'mui/Tooltip/LightTooltip';
import { formatDate } from 'services/date';

import ProjectedEvents from './ProjectedEvents/ProjectedEvents';
import EncounterCardButton from './EncounterCardButton';

import './EncounterCard.scss';

const EncounterCardContext = createContext();

function EncounterCard({ encounter }) {
  const { encounterName, noAppointments, events, start, end } = encounter;

  return (
    <EncounterCardContext.Provider
      value={{
        encounter
      }}
    >
      <div className={cx('encounter-card', { 'encounter-card-no-appointments': noAppointments })}>
        <div className="encounter-card-left">
          <div title={encounterName} className="encounter-card-name">
            {encounterName}
          </div>
          <div className="encounter-card-start-end-date">
            {formatDate(start)}
            {start && end && ' - '}
            {formatDate(end)}
            {!noAppointments && !isEmpty(events) && (
              <LightTooltip
                arrow
                title={<ProjectedEvents />}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -7]
                        }
                      }
                    ]
                  }
                }}
              >
                <EventBusyIcon />
              </LightTooltip>
            )}
          </div>
        </div>
        <div className="encounter-card-right">
          <EncounterCardButton />
        </div>
      </div>
    </EncounterCardContext.Provider>
  );
}

export default memo(EncounterCard);

export function useEncounterCard() {
  const context = useContext(EncounterCardContext);
  if (context === undefined) {
    throw new Error('useEncounterCard must be used within a EncounterCardContext.Provider');
  }
  return context;
}
